import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-4 px-8 rounded shadow-[0_0_15px_rgba(201,168,76,0.3)] transition-colors duration-300 ${className}`} {...props} data-id="element-29">
      <span className="block" data-id="element-30">{children}</span>
      <span className="block text-xs font-normal opacity-80 mt-1" data-id="element-31">
        + Impuestos según tu país
      </span>
    </motion.button>;
}